var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-primary"},[_c('app-tab',{attrs:{"tabs":_vm.tabsSuppliers,"active-tab":_vm.activeTab,"type":"horizontal","selectedUrl":_vm.selectedUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }